import axios, { AxiosResponse } from "axios";

export interface IdentityProvider {
	identityProviderId: string;
	identityProviderName: string;
}

export const getIdentityProviders = () => async (): Promise<AxiosResponse<IdentityProvider[]>> => {
	return await axios.get(`/api/v1/identityproviders`);
};
